import styled from 'styled-components';

export const HeaderStyled = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.color.grey300};
  padding: 20px 0;
  margin-bottom: 32px;

  > div {
    display: flex;
    align-items: center;

    h1 {
      color: ${({ theme }) => theme.color.grey900};
      font-size: 18px;
      font-weight: 500;
      line-height: 22px;
    }

    a {
      display: flex;
      align-items: center;
      margin-left: 24px;
      text-decoration: none;
      color: ${({ theme }) => theme.color.blue800};
      font-size: 16px;
      font-weight: 700;
      line-height: 22px;
      letter-spacing: 0.08px;

      > svg {
        margin-left: 4px;
        path {
          fill: ${({ theme }) => theme.color.blue800};
        }
      }
    }
  }

  > a {
    text-decoration: none;
    button {
      height: 38px;
      width: fit-content;
      background: ${({ theme }) => theme.color.white};

      > svg {
        path {
          fill: ${({ theme }) => theme.color.blue800};
        }
      }
    }
  }
`;
